import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSquareBehindSquare1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3.25C2 2.55964 2.55964 2 3.25 2H14.75C15.4404 2 16 2.55964 16 3.25V8H20.75C21.4404 8 22 8.55964 22 9.25V20.75C22 21.4404 21.4404 22 20.75 22H9.25C8.55964 22 8 21.4404 8 20.75V16H3.25C2.55964 16 2 15.4404 2 14.75V3.25ZM14.5 8H9.25C8.55964 8 8 8.55964 8 9.25V14.5H3.5V3.5H14.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
